import { Controller } from "stimulus"

// #1763: het schema op de desktop kleurt een afgeronde sessie groen. Wordt de
// training elders afgerond of weer geopend (tablet, Duo PT, sporter-app of
// handmatig afronden), dan volgt de kleur zonder dat de pagina herlaadt.
//
// Hetzelfde signaal als het trainingsscherm sinds 1735 (TabletKaartSignaal):
// de server vervangt het lege element schema_signaal_<id> in deze controller.
// Dan halen we alleen de lijst afgeronde sessies op en zetten of halen we
// is-afgerond op elk blok met data-sessie-afgerond-key. Velden, open vensters
// en de scrollpositie blijven zoals ze zijn.
const WACHT_MS = 300

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.observer = new MutationObserver((mutaties) => {
      const nieuw = mutaties.some((m) => Array.from(m.addedNodes).some((n) => n.dataset && n.dataset.nieuw))
      if (nieuw) this.planOphalen()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    clearTimeout(this.timer)
  }

  // Bij een afronding komen er meerdere signalen kort na elkaar; één keer ophalen
  planOphalen() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.ophalen(), WACHT_MS)
  }

  async ophalen() {
    try {
      const antwoord = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!antwoord.ok) return
      const gegevens = await antwoord.json()
      this.toepassen(new Set((gegevens.afgerond || []).map(String)))
    } catch (_fout) {
      // Geen verbinding: bij de volgende wijziging of het opnieuw openen klopt het weer
    }
  }

  toepassen(afgerond) {
    document.querySelectorAll("[data-sessie-afgerond-key]").forEach((blok) => {
      blok.classList.toggle(blok.dataset.sessieAfgerondKlasse || "is-afgerond", afgerond.has(blok.dataset.sessieAfgerondKey))
    })
    // #1854: per week het aantal afgeronde sessies (1/3) en pas bij 3/3 het vinkje
    document.querySelectorAll("[data-week-voortgang]").forEach((teller) => {
      const sessies = (teller.dataset.weekSessies || "").split(" ").filter(Boolean)
      const klaar = sessies.filter((key) => afgerond.has(key)).length
      teller.textContent = `${klaar}/${sessies.length}`
      if (teller.dataset.titelSjabloon) {
        teller.title = teller.dataset.titelSjabloon.replace("%{klaar}", klaar).replace("%{totaal}", sessies.length)
      }
      const vink = teller.parentElement && teller.parentElement.querySelector("[data-week-vink]")
      if (vink) vink.hidden = !(sessies.length > 0 && klaar === sessies.length)
    })
  }
}
